import React, { useContext, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react-lite";
import { UI } from "@wwimmo/ui";
import { Route, selectRoute } from "src/config/routes";
import styles from "./InvoiceDuplicatesModal.module.css";
import { formatCurrency } from "src/utils/Currency";

const InvoiceDuplicatesModalBase = () => {
    const { t } = useTranslation();
    const { authStore, invoiceStore } = useContext(RootStoreContext);

    const toggleDisplayDuplicateModal = useCallback(() => {
        if (invoiceStore.currentInvoice) {
            invoiceStore.currentInvoice.setIsDuplicateModalDisplayed(
                !invoiceStore.currentInvoice!.isDuplicateModalDisplayed
            );
        }
    }, [invoiceStore.currentInvoice]);

    return (
        <UI.Modal
            title={t("screens.kredi_flow.duplicates.modal.title").toString()}
            size="lg"
            show={
                invoiceStore.currentInvoice && invoiceStore.currentInvoice.isDuplicateModalDisplayed
                    ? invoiceStore.currentInvoice.isDuplicateModalDisplayed
                    : false
            }
            onClose={toggleDisplayDuplicateModal}
            centered={true}
            backdrop="static"
            isScrollable={true}
        >
            <UI.Row className={"mt-2"}>
                <UI.Col sm={12}>
                    <div className={`${styles.InvoiceDuplicatesWarningBox} d-flex`}>
                        <div className="mr-2">
                            <UI.Icon icon={UI.SVGIcon.AlertTriangle} />
                        </div>

                        <div>
                            <div> {t("screens.kredi_flow.duplicates.modal.warning")} </div>
                            <div> {t("screens.kredi_flow.duplicates.modal.click_entry")}</div>
                        </div>
                    </div>
                    <div className={`${styles.InvoiceDuplicateListHeader} d-flex align-items-center`}>
                        <div style={{ flex: 0.1 }}>{t("screens.kredi_flow.history.number")}</div>
                        <div style={{ flex: 0.5 }}>{t("screens.kredi_flow.list.creditor")}</div>
                        <div style={{ flex: 0.4 }}>{t("screens.kredi_flow.list.amount")}</div>
                    </div>
                    <div>
                        {invoiceStore.currentInvoice &&
                            invoiceStore.currentInvoice.duplicates?.map((duplicate, index) => {
                                return (
                                    <a
                                        key={`duplicate-entry-${index}`}
                                        style={{ textDecoration: "none" }}
                                        href={selectRoute(Route.invoiceDetails, authStore.user?.role, {
                                            invoicenumber: duplicate.invoiceNumber.toString()
                                        })}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <div className={`${styles.InvoiceDuplicateListItem} d-flex align-items-center`}>
                                            <div style={{ flex: 0.1 }}>{duplicate.invoiceNumber}</div>
                                            <div style={{ flex: 0.5 }}>
                                                {invoiceStore.currentInvoice?.creditor?.name}
                                            </div>
                                            <div style={{ flex: 0.4 }}>{formatCurrency(duplicate.amount)}</div>
                                        </div>
                                    </a>
                                );
                            })}
                    </div>
                    <div>
                        <UI.Button
                            className={styles.InvoiceDuplicatesModalButton}
                            label={t("labels.ok").toUpperCase()}
                            onClick={toggleDisplayDuplicateModal}
                        />
                    </div>
                </UI.Col>
            </UI.Row>
        </UI.Modal>
    );
};

export const InvoiceDuplicatesModal = Sentry.withProfiler(observer(InvoiceDuplicatesModalBase));
